import script from "./CountrySelector.vue?vue&type=script&lang=js"
export * from "./CountrySelector.vue?vue&type=script&lang=js"

export default script